// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1-W56","footer":"ModalUpdate_footer__2Yws4"};